module.exports = __webpack_public_path__ + "assets/assets/images/illustrations/help.24813d36.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/illustrations/help.png
// module id = 402
// module chunks = 0